import axios from 'axios';
import { setInterceptors } from '@/api/common/interceptor';

function createInstance() {
    return axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset = utf-8',
        },
    });
}

// axios 생성 
function createInstanceWithUrl() {
    const instance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset = utf-8',
        },
    });
    return setInterceptors(instance);
}

// multipart axios 생성
function createInstanceFormWithUrl() {
    const instance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'multiparti/form-data;',
        },
    });
    return setInterceptors(instance);
}

export const instance = createInstance();
export const instantsInterceptor = createInstanceWithUrl();
export const instantsInterceptorFormData = createInstanceFormWithUrl();